"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidCheckboxValue = isValidCheckboxValue;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var RuleEditorCheckbox = function RuleEditorCheckbox(_ref) {
  var atom = _ref.atom,
      value = _ref.value,
      setValue = _ref.setValue;
  return /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
    checked: Boolean(value || atom.default),
    onChange: function onChange(e) {
      setValue(e.target.checked);
    }
  });
};

var _default = RuleEditorCheckbox;
exports.default = _default;

function isValidCheckboxValue(atom) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      value = _ref2.value;

  return atom.type === "checkbox" && (value === true || value === false);
}